import React from 'react';

import { ListItem } from '../../types/ListItem';
import { Box } from '../Box/Box';
import { Icon } from '../Icon/Icon';
import { Layout } from '../Layout/Layout';
import { Text } from '../Text/Text';

interface ListItemsProps {
  as: 'ol' | 'ul';
  items: ListItem[];
  enablePadding?: boolean;
  mode?: 'default' | 'compact';
}

export const ListItems = ({
  as,
  items,
  enablePadding,
  mode = 'default',
}: ListItemsProps) => {
  const isCompactMode = mode === 'compact';

  return (
    <Layout
      as={as}
      spacing={enablePadding || isCompactMode ? undefined : '4'}
      direction="column"
      pl="0"
      pr="0"
    >
      {items.map((item, index) => (
        <Layout
          key={`list-item-${index}`}
          direction="column"
          onClick={item.onClick}
          bg={item.isSelected ? 'status.info.secondary' : undefined}
          p={enablePadding ? '4' : undefined}
        >
          <Layout>
            {item.icon && (
              <Box mr="2">
                <Icon
                  color={item.iconColor ?? 'status.info'}
                  icon={item.icon}
                />
              </Box>
            )}
            <Text variant={isCompactMode ? 'tiny' : 'body-medium'}>
              {item.title}
            </Text>
          </Layout>
          <Text>{item.description}</Text>
        </Layout>
      ))}
    </Layout>
  );
};
